import { Component, Input } from '@angular/core';
import { PocketbaseService } from '../../services/pocketbase.service';
import { Course } from '../../interfaces/courseInterface';
import { NgIconComponent } from '@ng-icons/core';
import { RouterLink } from '@angular/router';
import { DemoBannerComponent } from "../../components/demo-banner/demo-banner.component";

@Component({
    selector: 'app-endless-start',
    imports: [RouterLink, NgIconComponent, DemoBannerComponent],
    templateUrl: './start.component.html',
    styleUrl: './start.component.scss'
})
export class EndlessStartComponent {
  public course: Course | undefined;

  @Input()
  set id(courseId: string){
    this.pocketbaseService.pb.collection('courses').getOne<Course>(courseId).then(course => {
      this.course = course;
    });
  }

  constructor(private pocketbaseService: PocketbaseService){}
}
